<template lang="pug">
div
  .d-flex(v-if="isLoading")
    .d-flex.fd-column.flex-1
      v-progress-linear(color='primary' indeterminate='' rounded='' height='3')
      small.text-muted.font-size-10 obteniendo lista...
  .d-flex.flex-wrap(v-if="!isLoading && !small")
    .estado-dot(v-for="(e, index) in estados", @click="selectEstado(e)")
      v-tooltip(top='')
        template(v-slot:activator='{ on, attrs }')
          v-icon( :size="small ? 14 : 28" :color="e.orden <= estado.orden ?  `${ !small  && 'primary'}` : 'background'" v-bind='attrs' v-on='on', v-if="tipo === 'garantia'")
            | fiber_manual_record
          v-icon( :size="small ? 14 : 28" :color="e.codigo <= estado.codigo ?  `${ !small  && 'primary'}` : 'background'" v-bind='attrs' v-on='on', v-else)
            | fiber_manual_record
        small {{e.descripcion}}
  .d-flex(v-if="!isLoading", :class="{'jc-center ai-center' : showClear}")
    .text-left(v-if="estado && estado.descripcion")
      small.font-size-10.text-muted(v-if="small") {{`Etapa: ${etapa}`}} / {{estado.descripcion.substring(0, 30)}}
      small.font-size-13.primary--text.font-weight-700(v-else)  {{estado.descripcion}}
    v-divider.mx-2(v-if="showClear")
    .ml-3(v-if="showClear")
      v-btn( link :disabled="!estado.codigo" x-small color="error", @click="limpiarEstado(true)")
        | Limpiar

</template>
<script>
import { apiGet, notify } from '../util/general'
export default {
  props : {
    tipo : {
      type   : String,
      default: ''
    },
    codigo : {
      type   : Number,
      default: 0
    },
    readOnly : {
      type   : Boolean,
      default: false
    },
    showClear : {
      type   : Boolean,
      default: false
    },
    small : {
      type   : Boolean,
      default: false
    },
    etapa : {
      type : Number,
      default : 0
    }
  },
  data () {
    return {
      lista      : [],
      estado       : {},
      isLoading    : false,
      codigoEnviado: this.codigo
    }
  },
  created () {
    var vm = this
    console.log('tipo', vm.tipo)
    vm.fetch()
  },
  computed: {
    estados () {
      // if (this.tipo === 'incidencia con equipo' && this.estado.codigo === 9) {
      //   return this.lista
      // } else {
      //   if (this.tipo === 'incidencia con equipo') {
      //     console.log('filtado...',  this.lista)
      //     return this.lista
      //   } else return this.lista
      // }
      return this.lista
    }
  },
  methods : {
    reload () {
      var vm = this
      vm.$forceUpdate();
    },
    limpiarEstado (emit = false) {
      var vm = this
      vm.estado = {}
      vm.codigoEnviado = 0
      if (emit) vm.$emit('selected', vm.estado)
    },
    selectEstado (estado) {
      var vm = this
      if (vm.readOnly) return
      vm.estado = estado
      vm.$emit('selected', estado)
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        tipo : vm.tipo
      }

      if (vm.etapa) obj.etapa = vm.etapa

      apiGet(vm, '/estado/obtener', obj, function (data) {
        vm.lista = data.lista
        if (vm.codigoEnviado > 0) {
          vm.estado = vm.lista.find(e => e.codigo === vm.codigoEnviado)
          vm.estado && vm.selectEstado(vm.estado)
        }
        if (!vm.estado) {
          vm.estado = {
            codigo     : 0,
            descripcion: 'Desconocido'
          }
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.estado-dot
  cursor pointer
</style>



// WEBPACK FOOTER //
// c_estados_tickets.vue?387b499e